<template>
  <div class="card">
    <div class="card-header"><i class="icon-refresh"></i> Filtrer</div>
    <div class="card-block">
      <div class="row">
        <div class="form-group col-sm-4">
          <label>A partir du</label>
          <datepicker
            v-model="filters.start"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>
        <div class="form-group col-sm-4">
          <label>Coach manager</label>
          <multiselect
            v-model="filters.coachManager"
            :options="coachManagersOptions"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect"
            placeholder="Sélectionner une ou plusieurs options"
          >
          </multiselect>
        </div>
        <div class="form-group col-sm-4">
          <label>B2C / B2B / Marchés publics</label>
          <multiselect
            v-model="filters.type"
            :options="typesOptions"
            :multiple="true"
            label="label"
            track-by="label"
            class="custom-multiselect"
            placeholder="Sélectionner une ou plusieurs options"
          >
          </multiselect>
        </div>
        <div class="form-group col-sm-4">
          <label>Rechercher un coach</label>
          <el-input v-model="filters.name" placeholder="Nom, Prénom, Email" />
        </div>
      </div>
    </div>
    <div class="card-footer">
      <button
        type="button"
        class="btn btn-sm btn-secondary"
        @click="applyFilters"
      >
        <i class="icon-eye"></i>&nbsp; Visualiser
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Multiselect,
    Datepicker,
  },

  data() {
    return {
      filters: {
        start: moment().startOf("day").toDate(),
        coachManager: [],
        type: [],
        name: "",
      },
      typesOptions: [
        { label: "B2C", value: "isB2C" },
        { label: "B2B", value: "isB2B" },
        { label: "Marchés publics", value: "marketEstablishment" },
      ],
      coachManagersOptions: [],
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },

  async created() {
    await this.fetchCoachManagers();

    if (this.user.coachManager) {
      this.filters.coachManager = this.coachManagersOptions.filter(
        (opt) => opt.value === this.user.email
      );

      this.filters.type = this.typesOptions.filter(
        (opt) => !!this.user.coachManager[opt.value]
      );
    }

    this.applyFilters();
  },

  methods: {
    applyFilters() {
      this.$emit("applyFilters", {
        ...this.filters,
        coachManager: this.filters.coachManager.map((cm) => cm.value),
        type: this.filters.type.map((t) => t.value),
      });
    },

    async fetchCoachManagers() {
      try {
        const { data } = await this.$api.get("/users/coach-managers");

        this.coachManagersOptions = data.map((c) => ({
          value: c.email,
          label: c.coachManager.pseudo,
        }));
      } catch (e) {
        this.coachManagersOptions = [];
      }
    },
  },
};
</script>
